import { RULE_SET } from "constants/actionTypes";

import { offlineCrudReducer } from "lib/reducers";
import { deserializeRuleSet as ruleSetDeserializer } from "lib/serializers/ruleSets";

export const ruleSetReducer = offlineCrudReducer(RULE_SET, {
  deserializer: ruleSetDeserializer,
});
